//import axios, { AxiosResponse } from "axios";
import {
  // getCustomizedTitle,
  getRetailersArrayToPrase,
} from "pricePinger-shared/dist/utils";
import {
  fetchProductSuggestionAPIFromWP,
  serviceFetchRetailersConfig,
  // serviceGetCustomizedTitleParams,
} from "src/api/service/services";
import { scrapeRetailersInParallel } from "src/component/common/Search/ParseRetailersSearch/parseReteilerInParallel";

const fetchRetailersToScrapeConfig = async () => {
  try {
    const response = await serviceFetchRetailersConfig();
    const retailers = response?.data?.result?.retailer_to_scrape;
    if (!retailers) {
      console.error("No retailers found in the response");
      return [];
    }
    // Filter out any retailer with the name 'CROMA'
    const filteredRetailers = retailers.filter(
      (retailer: any) => retailer?.retailer !== "CROMA"
    );
    return filteredRetailers; // Correctly return the filtered array
  } catch (error) {
    console.error("Error fetching retailers config", error);
    return []; // Return an empty array in case of error
  }
};

const fetchFinalProductSuggestions = async (query: string) => {
  try {
    const response = await fetchProductSuggestionAPIFromWP(query); // Replace with your API endpoint
    const suggestions = response?.data || [];
    return suggestions; // Get only the first 12 records by default
  } catch (error) {
    console.error("Error fetching final product suggestions", error);
    return [];
  }
};

export const handleSearchfromSharedLibrary = async (query: string) => {
  try {
    /*  let customizedTitle: string;
    const customizedTitleParams = serviceGetCustomizedTitleParams();
    if (query !== "") {
      customizedTitle = await getCustomizedTitle(
        query,
        customizedTitleParams,
        axios
      );
      console.log("Customized Title", customizedTitle);
    } */
    const retailersToScrapeConfig = await fetchRetailersToScrapeConfig();
    const retailersToScrape = await getRetailersArrayToPrase(
      retailersToScrapeConfig,
      ""
    );
    await scrapeRetailersInParallel(retailersToScrape, query);
    const finalSuggestions = await fetchFinalProductSuggestions(query);
    if (finalSuggestions.length === 0) {
      // Fallback to results.filter(Boolean) if suggestions are empty

      return { message: "No Product Found" };
    } else {
      return finalSuggestions;
    }
  } catch (error) {
    console.error("Error fetching data from shared library", error);
  }
};
